import { createFileRoute } from '@tanstack/react-router'
import { AdminAnalyticsPage } from '@/features/overview/pages/admin-analytics-page'
import { parseAnalyticsSearch } from '@/features/overview/lib/analytics-search'

export const Route = createFileRoute('/analytics')({
  staticData: { title: 'Analytics' },
  validateSearch: parseAnalyticsSearch,
  component: AdminAnalyticsPage,
})
